import { render } from "./Question.vue?vue&type=template&id=13ff0964&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=13ff0964&lang=scss&scoped=true"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ff0964"]])

export default __exports__